// Facilitator color scheme - predefined colors mapping to Tailwind CSS classes
// Static configuration object for consistent styling across admin components
export const facilitatorColors = {
  // Standard colors from Staff table
  'pink': { bg: 'bg-pink-100', border: 'border-pink-200', text: 'text-pink-700' },
  'gold': { bg: 'bg-yellow-100', border: 'border-yellow-200', text: 'text-yellow-700' },
  'blue': { bg: 'bg-blue-100', border: 'border-blue-200', text: 'text-blue-700' },
  'green': { bg: 'bg-green-100', border: 'border-green-200', text: 'text-green-700' },
  'purple': { bg: 'bg-purple-100', border: 'border-purple-200', text: 'text-purple-700' },
  'red': { bg: 'bg-red-100', border: 'border-red-200', text: 'text-red-700' },
  'orange': { bg: 'bg-orange-100', border: 'border-orange-200', text: 'text-orange-700' },
  'teal': { bg: 'bg-teal-100', border: 'border-teal-200', text: 'text-teal-700' },
  'indigo': { bg: 'bg-indigo-100', border: 'border-indigo-200', text: 'text-indigo-700' },
  'cyan': { bg: 'bg-cyan-100', border: 'border-cyan-200', text: 'text-cyan-700' },
  'emerald': { bg: 'bg-emerald-100', border: 'border-emerald-200', text: 'text-emerald-700' },
  'lime': { bg: 'bg-lime-100', border: 'border-lime-200', text: 'text-lime-700' },
  'amber': { bg: 'bg-amber-100', border: 'border-amber-200', text: 'text-amber-700' },
  'violet': { bg: 'bg-violet-100', border: 'border-violet-200', text: 'text-violet-700' },
  'fuchsia': { bg: 'bg-fuchsia-100', border: 'border-fuchsia-200', text: 'text-fuchsia-700' },
  'rose': { bg: 'bg-rose-100', border: 'border-rose-200', text: 'text-rose-700' },
  'sky': { bg: 'bg-sky-100', border: 'border-sky-200', text: 'text-sky-700' },
  'slate': { bg: 'bg-slate-100', border: 'border-slate-200', text: 'text-slate-700' },
  
  // Default fallback
  'gray': { bg: 'bg-gray-100', border: 'border-gray-200', text: 'text-gray-700' }
};

// Get facilitator color based on facilitator color field
export const getFacilitatorColor = (session) => {
  const facilitatorColor = session.facilitatorColor;
  if (facilitatorColor && facilitatorColors[facilitatorColor]) {
    return facilitatorColors[facilitatorColor];
  }
  
  // Default to gray if no color specified or color not found
  return facilitatorColors.gray;
};